import * as React from 'react';

import { TagModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';

import ErrorBoundary from '@components/ErrorBoundary';
import PriceLabel from '@components/PriceLabel';
import { Tags } from '@components/Tags';
import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';
import { VariantDisplayTypes } from '@containers/ProductListing/model';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { dataLabelsProp } from '@helpers/utils';

import { IVariantProps } from '../../../../model';
import { trackVariantClick } from '../../tracking';
import { VariantLink, PriceLabelCurrency } from '../../variantsStyled';

import {
  PriceLabelWrapper,
  Variant,
  ImgWrapper,
  Img,
  VariantListItem,
  PricePlaceholder,
} from './styled';

export const VariantThumbnail: React.FC<IVariantProps> = ({
  item,
  isSelected,
  displayPrice,
  variantsCount,
}) => {
  const isOnStock = item.stockAvailability.code !== IStock.outOfStock;
  const { getTimeFromInit } = useTrackingContext();
  const newDesign = useNewPdDesignEnabled();
  const displayInRow = variantsCount === 2;

  const handleClick = () =>
    trackVariantClick(getTimeFromInit(), VariantDisplayTypes.Thumbnail);

  return (
    <VariantListItem newDesign={newDesign}>
      <ErrorBoundary>
        <VariantLink
          onClick={handleClick}
          replace={true}
          to={item.url}
          id={`pd-variant-${item.webId}`}
          className={isSelected ? 'pd-variant-selected' : ''}
          {...dataLabelsProp(item.attributes)}
        >
          <Variant
            displayInRow={displayInRow}
            newDesign={newDesign}
            isOnStock={isOnStock}
            isSelected={isSelected}
          >
            {item.attributes && (
              <Tags
                small={newDesign}
                type={TagModel.Types.corner}
                attributes={item.attributes}
                stockAvailability={item.stockAvailability.code}
              />
            )}

            <ImgWrapper
              newDesign={newDesign}
              isOnStock={isOnStock}
              isSelected={isSelected}
            >
              <Img {...item.media.mainImage} sourceKey="thumb" />
            </ImgWrapper>

            {displayPrice && isOnStock ? (
              <PriceLabel
                price={item.price}
                wrapperComponent={(additionalProps) => (
                  <PriceLabelWrapper
                    data-cypress="variant-thumbnail-price"
                    newDesign={newDesign}
                    isSelected={isSelected}
                    isOnStock={isOnStock}
                    {...additionalProps}
                  />
                )}
                currencyComponent={PriceLabelCurrency}
              />
            ) : displayInRow ? null : (
              <PricePlaceholder />
            )}
          </Variant>
        </VariantLink>
      </ErrorBoundary>
    </VariantListItem>
  );
};
